module.exports = __webpack_public_path__ + "static/img/rest22.c355a36.jpg";


//////////////////
// WEBPACK FOOTER
// ./src/assets/rest22.jpg
// module id = w4bD
// module chunks = 0